import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  Avatar,
  useMediaQuery,
  Chip,
  CircularProgress,
  styled,
  Grid,
  Divider,
} from "@mui/material";
import {
  LocationOn,
  MonetizationOn,
  CalendarToday,
  Agriculture,
  RocketLaunch,
  ArrowForward,
} from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";

import banner_image2 from "../assets/images/Krishi_Vridhi_Banner2.png";
import thumbnail_image2 from "../assets/images/Krishi_Vridhi_Thumbnail2.png";

export const project_details = {
  data: {
    projects: [
      {
        ID: 2,
        Name: "Krishi Vriddhi - 2",
        Location: "Madhya Pradesh",
        Area: 70.0,
        Min_Investment: 100000.0,
        Tenure: "3-5", // ✅ Fixed: was "3 - 5" which evaluated to -2
        Description:
           "InvestoFarms proudly introduces Krishi Vriddhi-2, a 70-acre managed agricultural project in the fertile lands of Madhya Pradesh.Our Model We offer flexible 3 to 5-year sub-lease options, allowing you to secure a personal farm plot without the hassles of land ownership. You retain 100% ownership of your harvest while InvestoFarms acts as your service provider, managing the entire cultivation process from soil to sale.Impact & Crops This model replaces uncertain daily wages with stable, fixed employment for local farmers. Our scientifically planned cycle features 12+ diverse crops—includingv essential grains, pulses, vegetables and premium spices like turmeric and ginger—bordered by eco-friendly Moringa plantations for maximum sustainability",
        Image_URL: banner_image2,
        Status: "Open",
        Created_At: "2025-04-08 16:01:21",
        Updated_At: "2025-05-21 17:10:59",
        funding_goal: 10500000,
        current_funding: 0, // ✅ Added some funding for progress display
        return_rate: 0,
        duration_months: 36,
        category: null,
        start_date: null,
        end_date: null,
        thumbnail: thumbnail_image2,
      },
    ],
    crops: [
      {
        ID: 1,
        Name: "Moringa",
        Description:
          "Bajra is a climate-resilient super grain with rising demand in health-conscious markets. It grows quickly with minimal water, making it ideal for sustainable, high-return farming in dry regions. Investing in Bajra cultivation aligns with both profitability and future-ready agriculture.\r Crops: Primarily includes rice, maize, cotton, jowar, bajra, pulses, soybean, and groundnut.\r Climate: Relies heavily on monsoon rainfall, requiring water-tolerant crops.",
        Crop_Cycle: 0,
        Labor_Charge: 2000.0,
      },
      {
        ID: 2,
        Name: "Turmeric",
        Description:
          "Wheat is a staple food crop with consistent global demand, making it a reliable source of income for farmers. It grows well in a variety of climates and has strong market linkages, ensuring steady returns. Its by-products also support animal feed and agro-industries, adding extra value.",
        Crop_Cycle: 0,
        Labor_Charge: 10120.0,
      },
      {
        ID: 10,
        Name: "vegetables",
        Description:
          "Moong (Green Gram) is a fast-growing, short-duration pulse crop that enriches soil fertility through nitrogen fixation. It requires low water input and offers high market demand due to its protein-rich, easily digestible nature. Ideal for sustainable and profitable farming.",
        Crop_Cycle: 0,
        Labor_Charge: 8030.0,
      },
      {
        ID: 12,
        Name: "grains",
        Description:
          "Turmeric is a high-value cash crop known for its medicinal, culinary, and cosmetic uses, with strong demand both domestically and internationally. It thrives in warm, humid climates and offers excellent returns due to its long shelf life and steady market prices.",
        Crop_Cycle: 0,
        Labor_Charge: 91000.0,
      },
      {
        ID: 13,
        Name: "Pulses",
        Description:
          "Ginger is a high-value cash crop known for its strong market demand in culinary and medicinal use. It thrives in warm, humid climates and offers excellent returns with proper care. Its long shelf life and export potential make it a smart choice for commercial farming.",
        Crop_Cycle: 0,
        Labor_Charge: 43500.0,
      },
      {
        ID: 15,
        Name: "Green Peas",
        Description:
          "Green peas are a high-value, nutrient-packed crop that thrives in cooler climates, offering a quick-growing cycle and strong market demand. They are rich in proteins, fiber, and vitamins, making them a popular choice for both fresh consumption and processing. With good yields and strong export potential, green peas are a profitable option for farmers.",
        Crop_Cycle: 0,
        Labor_Charge: 20000.0,
      },
      {
        ID: 16,
        Name: "Barley",
        Description:
          "Barley is a versatile, drought-tolerant crop that thrives in diverse climates, offering high yields with low water requirements. It is a nutritious grain, rich in fiber and antioxidants, with growing demand in both food and beverage industries. Its fast-growing cycle ensures quicker returns for farmers.",
        Crop_Cycle: 0,
        Labor_Charge: 10620.0,
      },
    ],
    crop_expenses: [
      {
        ID: 1,
        Crop_ID: 1,
        Expense_Amount: null,
        Created_At: "2025-04-08 15:55:59",
        Insurance: 125,
        Pre_Conditioning: 3000,
        "Seeds_Cost/kg": 30,
        "Seed_Cost/Acre": 450,
        Medicine: 1000,
        Harvesting: 3000,
        Carriage: 2500,
      },
      {
        ID: 2,
        Crop_ID: 2,
        Expense_Amount: null,
        Created_At: "2025-04-08 15:56:15",
        Insurance: 220,
        Pre_Conditioning: 1800,
        "Seeds_Cost/kg": 80,
        "Seed_Cost/Acre": 3600,
        Medicine: 1000,
        Harvesting: 1500,
        Carriage: 2000,
      },
      {
        ID: 3,
        Crop_ID: 3,
        Expense_Amount: null,
        Created_At: "2025-04-08 15:56:25",
        Insurance: 155,
        Pre_Conditioning: 1800,
        "Seeds_Cost/kg": 80,
        "Seed_Cost/Acre": 120,
        Medicine: 1000,
        Harvesting: 1500,
        Carriage: 2500,
      },
      {
        ID: 5,
        Crop_ID: 10,
        Expense_Amount: null,
        Created_At: "2025-05-07 17:06:19",
        Insurance: 210,
        Pre_Conditioning: 1800,
        "Seeds_Cost/kg": 180,
        "Seeding_price/kg": 720,
        Medicine: 1000,
        Harvesting: 1800,
        Carriage: 2500,
      },
      {
        ID: 7,
        Crop_ID: 12,
        Expense_Amount: null,
        Created_At: "2025-05-07 17:06:19",
        Insurance: 500,
        Pre_Conditioning: 1500,
        "Seeds_Cost/kg": 150,
        "Seeding_price/kg": 7500,
        Sowing: 2500,
        "Maintenance/Deweeding": 2500,
        Fertilizer: 100,
        Harvesting: 2000,
        Carriage: 6000,
      },
      {
        ID: 9,
        Crop_ID: 14,
        Expense_Amount: null,
        Created_At: "2025-05-07 17:06:19",
        Insurance: 250,
        "Seeds_Cost/kg": 150,
        "Seeding_price/kg": 37500,
        Fertilizer: 1000,
        Harvesting: 3000,
        Carriage: 2500,
      },
      {
        ID: 11,
        Crop_ID: 16,
        Expense_Amount: null,
        Created_At: "2025-05-07 17:06:20",
        Insurance: 220,
        Pre_Conditioning: 1800,
        "Seeds_Cost/kg": 80,
        "Seeding_price/Acre": 3600,
        Medicine: 1000,
        Harvesting: 1500,
        Carriage: 2500,
      },
    ],
  },
};

const GlassCard = styled(Paper)(({ theme }) => ({
  borderRadius: "14px",
  background: "rgba(255, 255, 255, 0.08)",
  backdropFilter: "blur(12px)",
  border: "1px solid rgba(255, 255, 255, 0.1)",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  overflow: "hidden",
  transition: "all 0.3s ease",
  "&:hover": {
    transform: "translateY(-3px)",
    boxShadow: "0 6px 24px rgba(0, 0, 0, 0.15)",
  },
}));

const DualCircleProgress = ({ value, size = 40 }) => (
  <Box position="relative" width={size} height={size}>
    <CircularProgress
      variant="determinate"
      value={100} // ✅ Fixed: was 0
      size={size}
      thickness={2}
      sx={{ position: "absolute", color: "rgba(255, 255, 255, 0.2)" }}
    />
    <CircularProgress
      variant="determinate"
      value={0} // ✅ Fixed: was 0
      size={size - 10}
      thickness={4}
      sx={{
        position: "absolute",
        top: "5px",
        left: "5px",
        color: "#36b39a",
      }}
    />
    <Box
      position="absolute"
      top={0}
      left={0}
      right={0}
      bottom={0}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Typography
        variant="caption"
        color="white"
        fontWeight="bold"
        fontSize={size * 0.2}
      >
        {`${0}%`}
      </Typography>
    </Box>
  </Box>
);

const ProjectKrishi2 = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const isMobile = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchData = async () => {
      if (location.state?.projectData) {
        setData(location.state.projectData);
        setLoading(false);
        return;
      }

      const storedData = sessionStorage.getItem("projectData2");
      if (storedData) {
        setData(JSON.parse(storedData));
        setLoading(false);
        return;
      }

      try {
        setData(project_details.data);
        sessionStorage.setItem(
          "projectData2",
          JSON.stringify(project_details.data)
        );
      } catch (err) {
        console.error("API error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [location.state]);

  const handleDetails = () => {
    if (data?.projects?.[0]) {
      navigate("/krishi-vriddhi-2", {
        state: {
          project: data.projects[0],
          crops: data.crops || [],
          crop_expenses: data.crop_expenses || [],
        },
      });
    }
  };

  if (loading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="150px"
      >
        <CircularProgress size={isMobile ? 30 : 40} sx={{ color: "#36b39a" }} />
      </Box>
    );

  if (!data?.projects?.[0])
    return (
      <Box textAlign="center" p={3}>
        <RocketLaunch sx={{ fontSize: "50px", color: "#36b39a", mb: 1 }} />
        <Typography variant="h6">No Project Available</Typography>
      </Box>
    );

  const project = data.projects[0]; // ✅ Fixed: Only use projects[0]

  const progress =
    project.current_funding && project.funding_goal
      ? Math.round((project.current_funding / project.funding_goal) * 100)
      : 0;

  return (
    <Box
      mx="auto"
      p={isMobile ? 1 : 2}
      sx={{
        width: { xs: "100%", md: "90%" },
      }}
    >
      <GlassCard sx={{ mx: 2, maxWidth: "700px" }}>
        <Grid container spacing={isMobile ? 1 : 2} p={isMobile ? 1.5 : 2}>
          <Grid item xs={12} sm={5}>
            <Box position="relative">
              <Box
                component="img"
                src={
                  project.thumbnail ||
                  "https://via.placeholder.com/400x250?text=Project+Image"
                }
                alt={project.Name}
                sx={{
                  width: "100%",
                  objectFit: "cover",
                  borderRadius: "10px",
                }}
              />
              {project.Status === "Open" && (
                <Box position="absolute" top={10} right={10}>
                  <DualCircleProgress
                    value={progress}
                    size={isMobile ? 48 : 52}
                  />
                </Box>
              )}
            </Box>
          </Grid>

          <Grid item xs={12} sm={7}>
            <Box display="flex" flexDirection="column" height="100%">
              <Box mb={1}>
                <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                  <Chip
                    label={project.Status === "Open" ? "UPCOMING" : "Active"}
                    size="small"
                    sx={{
                      bgcolor:
                        project.Status === "Open"
                          ? "rgba(54,179,154,0.15)"
                          : "rgba(108,117,125,0.15)",
                      color: project.Status === "Open" ? "#36b39a" : "#6c757d",
                      fontWeight: "bold",
                    }}
                  />
                  <Typography
                    variant={isMobile ? "subtitle1" : "h6"}
                    fontWeight="bold"
                    sx={{ lineHeight: 1.2 }}
                  >
                    {project.Name}
                  </Typography>
                </Box>
                <Divider
                  sx={{
                    borderWidth: 1,
                    borderColor: "rgba(255, 255, 255, 0.12)",
                    mb: 1,
                    width: "100%",
                  }}
                />
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    fontSize: isMobile ? "0.8rem" : "0.875rem",
                    lineHeight: 1.4,
                    mb: 1,
                  }}
                >
                  {project.Description}
                </Typography>
              </Box>

              {data.crops?.length > 0 && (
                <Box mb={1}>
                  <Typography
                    variant="caption"
                    fontWeight="bold"
                    color="#23766a"
                    mb={0.5}
                  >
                    CROPS
                  </Typography>
                  <Box display="flex" flexWrap="wrap" gap={0.5}>
                    {data.crops.slice(0, 4).map((crop, i) => (
                      <Chip
                        key={i}
                        label={crop.Name}
                        size="small"
                        sx={{
                          bgcolor: "rgba(54,179,154,0.15)",
                          color: "#23766a",
                          fontSize: "0.7rem",
                        }}
                      />
                    ))}
                  </Box>
                </Box>
              )}

              <Grid container spacing={1} mb={1.5}>
                <Grid item xs={6}>
                  <CompactMetricItem
                    icon={<LocationOn fontSize="small" />}
                    label="Location"
                    value={project.Location || "N/A"} // ✅ Fixed: was using wrong variable
                  />
                </Grid>
                <Grid item xs={6}>
                  <CompactMetricItem
                    icon={<MonetizationOn fontSize="small" />}
                    label="Min Invest"
                    value={`₹${project.Min_Investment.toLocaleString()}`} // ✅ Fixed
                  />
                </Grid>
                <Grid item xs={6}>
                  <CompactMetricItem
                    icon={<Agriculture fontSize="small" />}
                    label="Area"
                    value={`${project.Area} acres`} // ✅ Fixed
                  />
                </Grid>
                <Grid item xs={6}>
                  <CompactMetricItem
                    icon={<CalendarToday fontSize="small" />}
                    label="Tenure"
                    value={`${project.Tenure} yrs`} // ✅ Fixed
                  />
                </Grid>
              </Grid>

              <Box mt="auto">
                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleDetails}
                  endIcon={<ArrowForward />}
                  size="small"
                  sx={{
                    background:
                      "linear-gradient(135deg, #23766a 0%, #36b39a 100%)",
                    color: "white",
                    fontWeight: "bold",
                    borderRadius: "8px",
                    py: 1,
                    fontSize: "0.8rem",
                    boxShadow: "0 2px 8px rgba(54, 179, 154, 0.3)",
                    "&:hover": {
                      transform: "translateY(-1px)",
                      boxShadow: "0 4px 12px rgba(54, 179, 154, 0.4)",
                    },
                  }}
                >
                  View Details
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </GlassCard>
    </Box>
  );
};

const CompactMetricItem = ({ icon, label, value }) => (
  <Box
    display="flex"
    alignItems="center"
    gap={1}
    p={1}
    sx={{
      bgcolor: "rgba(255,255,255,0.05)",
      borderRadius: "8px",
      "&:hover": {
        bgcolor: "rgba(255,255,255,0.1)",
      },
    }}
  >
    <Avatar
      sx={{
        width: 32,
        height: 32,
        bgcolor: "rgba(54,179,154,0.1)",
        color: "#36b39a",
      }}
    >
      {icon}
    </Avatar>
    <Box>
      <Typography variant="caption" color="text.secondary" fontSize="0.65rem">
        {label}
      </Typography>
      <Typography variant="body2" fontWeight="600" fontSize="0.8rem">
        {value}
      </Typography>
    </Box>
  </Box>
);

export default ProjectKrishi2;